import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import './Loading.scss';

const Loading = ({ container, url }) => {
  const Container = container;
  return (
    <Container className="text-center crowdaa-Loading crowdaa-Loading--animate">
      <img src={url} className="col-12" alt='logo' />
      <img src="/img/Powered by Crowdaa.png" className="crowdaa_powered col-12" alt='powered_by_crowdaa' />
      <div>
        <FormattedMessage id="player_loading" />
      </div>
    </Container>
  );
};

Loading.propTypes = {
  container: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  url: PropTypes.string.isRequired,
};

Loading.defaultProps = {
  container: 'p',
};

export default Loading;
